export function debounce(func, timeout = 150) {
  let timer;
  return (...args) => {
    if (!timer) {
      func.apply(this, args);
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = undefined;
    }, timeout);
  };
}

export function loadGoogleMaps(cb) {
  // Si yGoogle Maps ya está cargado,
  // lanzamos el callback directamente.
  if (document.querySelector('script[data-google-maps="true"]')) {
    return cb();
  }

  // Crear el script de Google Maps.
  const script = document.createElement('script');
  script.src =
    'https://maps.googleapis.com/maps/api/js?key=' +
    process.env.MIX_GOOGLE_PLACES_KEY +
    '&callback=initMap&region=SP&language=sp&libraries=places';
  script.async = true;
  script.setAttribute('data-google-maps', 'true');

  // Añade el callback cuando Google Maps inicie.
  window.initMap = cb;

  // Añade el script de Google a la cabecera.
  document.head.appendChild(script);
}

export function dataLayerPushPage(funnel, type, fullPage, pagename, page = null, data = {}) {
  if (typeof dataLayer === 'undefined') {
    return;
  }

  const path = window.location.pathname;

  const pageName = (fullPage ?? path)
    .slice(1)
    .split('/')
    .map(item =>
      item
        .split('-')
        .map(item => item.charAt(0).toUpperCase() + item.slice(1))
        .join('')
    )
    .join('-');

  var content = {
    event: 'pagina-virtual',
    page: fullPage ?? page + path,
    pagename: fullPage ? pageName : `${pagename}-${pageName}`,
    funnel: `${funnel}-${type}-mortgage`,
  };

  dataLayer.push({ ...content, ...data });
}

export function dataLayerPushEvent(funnel, type, action, actionTag, data = {}) {
  if (typeof dataLayer === 'undefined') {
    return;
  }

  var content = {
    event: 'evento-interactivo',
    'evento-interactivo-categoria': 'Simulador-' + (type === 'improve' ? 'Mejora' : 'Nueva') + 'Hipoteca',
    'evento-interactivo-accion': action,
    'evento-interactivo-etiqueta': actionTag,
    funnel: `${funnel}-${type}-mortgage`,
  };

  dataLayer.push({ ...content, ...data });
}
